import React, { useEffect, useRef, useState } from "react";
import { Button } from "@progress/kendo-react-buttons";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormTextField from "../../components/formFields/FormTextField";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { STATUSARRAY } from "../../_contstants/common";
import { closed } from "../../components/drawer/drawerSlice";
import { Typography } from "@progress/kendo-react-common";
import { RxCross1 } from "react-icons/rx";
import IconButton from "../../components/common/IconButton";
import {
  createTourService,
  getAllActiveTourServices,
  getAllTourServices,
  getTourServiceByID,
  updateTourService,
} from "./services/tourservice.services";
import { clearTourServiceDetails } from "./tourserviceSlice";
import FormCheckbox from "../../components/formFields/FormCheckbox";

const CreateTourService: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);

  const [formKey, setFormKey] = useState(1);

  const TourServiceDetail = useAppSelector(
    (state) => state.tourservice.TourServiceDetail
  );
  const TourServiceID = useAppSelector((state) => state.drawer.data);
  const formLoading = useAppSelector((state) => state.tourservice.formLoading);
  const isIndirect = useAppSelector((state) => state.drawer.isIndirect);

  useEffect(() => {
    if (TourServiceID) {
      dispatch(getTourServiceByID(TourServiceID));
    }
  }, [TourServiceID]);

  useEffect(() => {
    return () => {
      dispatch(clearTourServiceDetails());
      dispatch(closed());
    };
  }, []);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [TourServiceDetail]);

  const handleSubmit = async (values: any) => {
    try {
      if (!TourServiceID) {
        const insertPayload = {
          Title: values.Title ? values.Title : "",
          IsDisplayHome: values.IsDisplayHome ? values.IsDisplayHome : false,
          IsActive: values.IsActive === 1,
        };
        const response = await dispatch(createTourService(insertPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearTourServiceDetails());
          if (isIndirect) {
            dispatch(getAllActiveTourServices());
          } else {
            dispatch(getAllTourServices());
          }
        }
      } else {
        const editPayload = {
          ID: TourServiceID,
          Title: values.Title ? values.Title : "",
          IsDisplayHome: values.IsDisplayHome ? values.IsDisplayHome : false,
          IsActive: values.IsActive === 1,
        };
        const response = await dispatch(updateTourService(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearTourServiceDetails());
          dispatch(getAllTourServices());
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  const handleFormClose = () => {
    dispatch(closed());
  };

  return (
    <>
      {formLoading && <LoadingPanel gridRef={gridRef} />}
      <Form
        key={formKey}
        onSubmit={handleSubmit}
        initialValues={TourServiceDetail}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement style={{ width: "100%" }}>
            <GridLayout
              style={{
                display: "flex",
                flexWrap: "wrap",
              }}
              gap={{ rows: 10 }}
              cols={[{ width: "100%" }]}
            >
              <GridLayoutItem className="mui-drawer-header">
                <Typography.h4 className="m-0">
                  {TourServiceID ? "Update Tour Service" : "Add Tour Service"}
                </Typography.h4>
                <IconButton
                  type="button"
                  fillMode={"flat"}
                  themeColor={"dark"}
                  style={{ marginRight: 4 }}
                  onClick={() => dispatch(closed())}
                  icon={RxCross1}
                />
              </GridLayoutItem>
              <GridLayoutItem style={{ width: "100%" }}>
                <Field
                  name="Title"
                  label="Title"
                  placeholder="Title"
                  component={FormTextField}
                  validator={requiredValidator}
                  astrike={true}
                />
              </GridLayoutItem>
              <GridLayoutItem>
                <Field
                  name="IsDisplayHome"
                  label="Is Display Home"
                  component={FormCheckbox}
                />
              </GridLayoutItem>
              <GridLayoutItem style={{ width: "100%" }}>
                <Field
                  name={`IsActive`}
                  label="Status"
                  component={FormSelectionField}
                  validator={requiredValidator}
                  astrike={true}
                  placeholder="i.e. Active"
                  options={STATUSARRAY?.map((status: any) => {
                    return {
                      value: status?.value,
                      label: status?.label,
                    };
                  })}
                />
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  textAlign: "end",
                  marginTop: 20,
                  width: "100%",
                }}
              >
                <ButtonWithLoading
                  label={!TourServiceID ? "Save" : "Update"}
                  type="submit"
                  disabled={!formRenderProps.allowSubmit || formLoading}
                  loading={formLoading}
                />

                <Button
                  type="button"
                  fillMode={"outline"}
                  themeColor={"primary"}
                  style={{ marginLeft: 10 }}
                  onClick={handleFormClose}
                >
                  Cancel
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </FormElement>
        )}
      />
    </>
  );
};

export default CreateTourService;
